export default __webpack_public_path__ + "static/media/Trails of Blue.ffd56a2d.png";